export const GLOBAL_FAQ = [
  {
    q: "Quelle est votre zone d'intervention dans le Calvados ?",
    a: "Nous intervenons à Caen et dans tout le Calvados : Hérouville-Saint-Clair, Mondeville, Ifs, Bayeux, Deauville, Trouville-sur-Mer, Lisieux, Falaise, Argences, Ouistreham, Courseulles-sur-Mer et toutes les communes alentours.",
  },
  {
    q: "Le devis est-il vraiment gratuit ?",
    a: "Oui, totalement gratuit et sans engagement. Nous nous déplaçons sur place pour évaluer précisément les travaux et vous remettons un devis détaillé sous 48 heures.",
  },
  {
    q: "Êtes-vous assurés ?",
    a: "Toutes nos prestations sont couvertes par une assurance Responsabilité Civile Professionnelle. Vous êtes intégralement protégé en cas d'incident.",
  },
  {
    q: "Bénéficie-t-on du crédit d'impôt 50% ?",
    a: "Oui, les prestations d'entretien de jardin (tonte, taille de haie, débroussaillage) sont éligibles au crédit d'impôt service à la personne de 50%, dans la limite de 5 000 €/an.",
  },
  {
    q: "Sous quel délai intervenez-vous ?",
    a: "En urgence sous 24-48h pour les interventions de sécurité (arbre tombé, branche dangereuse). Pour les prestations classiques, nous planifions sous 7 à 15 jours selon la saison.",
  },
  {
    q: "Acceptez-vous les contrats d'entretien annuels ?",
    a: "Bien sûr. Nous proposons des forfaits annuels sur mesure pour particuliers, copropriétés et entreprises avec passages réguliers planifiés.",
  },
  {
    q: "Que comprend exactement votre prestation ?",
    a: "Toutes nos interventions incluent l'évacuation systématique des déchets verts et le nettoyage complet de votre terrain après chantier. Aucun supplément caché.",
  },
  {
    q: "Comment se passe une demande de devis ?",
    a: "Appelez-nous au 07 80 04 43 90, écrivez à schmittantony4@gmail.com, ou remplissez notre formulaire en ligne. Réponse sous 24h ouvrées.",
  },
];
